module.exports = __webpack_public_path__ + "img/20190925165158723.77d68b80.jpg";